var ezdia;
(function (ezdia) {
    var self;
    var pageParams = {};
    var actiontype = null;
    var validatorObj = {};
    var hastabfield = false;
    var accountKey = null;
    var briefObj = {};
    var showUpdateBtn = true;
    function getSelectedIdsMarkup(selIds) {
        var html = ezdia.templates.quickActions.quickActionSeletedId({
            text: selIds.join(', '),
            count: selIds.length,
            btnTitle: 'Copy Selected Ids'
        });
        $('#ez-js-form-item-info').html(html);
        ezdia.util.copyBtnAction({});
    }
    var formAllItemIds = function () {
        var itemIds = '';
        var data = "formtype=" + pageParams.formType;
        if ($('#accountName').val()) {
            data += "&accountName=" + $('#accountName').val();
        }
        var searchdata = getSearchQueryString();
        if (searchdata &&
            searchdata !== '' &&
            searchdata !== null &&
            searchdata !== undefined &&
            searchdata.length > 0) {
            data += "&searchCondition=" + searchdata;
        }
        $.ajax({
            type: 'POST',
            url: 'ListAllFormIds.htm',
            data: data,
            async: false,
            dataType: 'json',
            success: function (response) {
                itemIds = response;
            },
            error: function () {
                itemIds = '';
            }
        });
        return itemIds;
    };
    function toggleQuickLinks(selIds, clicked) {
        var id = this.id;
        var checked = $("#cb_" + id).is(':checked');
        if (!selIds.length) {
            $.ezdia.quickLinks.triggersOff('#ez-quick-action-links');
        }
        else if ((selIds.length === 1 && clicked) || checked) {
            $.ezdia.quickLinks.triggersOn('#ez-quick-action-links');
        }
    }
    function resetSelectedRow() {
        this.cache.editfrm.show().off();
        this.cache.editfrminputs.empty();
        $('#message').html('');
        $('.mceListBoxMenu').remove();
        $.ezdia.form.init();
    }
    function createGrp(fieldsObj) {
        var arr = [];
        var grpArray = [];
        $.each(fieldsObj, function (key, col) {
            var grp = col.groupName || 'default';
            if ($.inArray(grp, arr) === -1) {
                arr.push(grp);
                grpArray.push({
                    name: grp,
                    label: grp
                });
            }
        });
        var grps = $.ezdia.groupFormField.create(grpArray);
        var tabs = $.ezdia.groupFormField.tabs(grpArray);
        this.cache.editfrminputs.html(grps);
        $('#ez-sys-form-tabs').html(tabs);
        setTimeout(function () {
            $('#ez-desk-form-actions-wrapper').show();
            $('#ez-scroll-nav-pills').scrollingNav({
                clickable: true,
                offsets: ['ez-page-top-navbar', 'ez-js-form-top-info-and-nav']
            });
        }, 0);
    }
    var getMetaInfo = function () {
        $.ezdia.desk.getMetaObj({
            widgets: {
                brief: briefObj,
                comment: {},
                category: {}
            }
        });
        pageParams.itemMetaInfo = commentFieldsData();
    };
    function form(data, renderWidets) {
        var cache = this.cache;
        validatorObj = {};
        briefObj = {};
        hastabfield = false;
        $.ezdia.validate.destroy(cache.editfrm);
        $.ezdia.widgets.load(actiontype);
        getMarkup.call(this, data);
        $.ezdia.validate.create(validatorObj, cache.editfrm, hastabfield);
        getMetaInfo();
        if (!renderWidets) {
            createWidgets.call(this);
        }
    }
    function getMarkup(frmObj) {
        var _this = this;
        var cache = this.cache;
        var colModel = pageParams.colModel;
        var data = frmObj.data;
        var template = $.ezdia.template.get('generic-form-row', {
            'generic-form-row-additional-options': 'form-row-additional-options'
        });
        var formTemplate = $.ezdia.config.pageParams.formTemplate;
        var formInfoWrap = $('#ez-js-form-item-info');
        var isEmptyFormQInfo = true;
        showUpdateBtn = false;
        createGrp.call(this, colModel);
        if (formTemplate) {
            var handlebarsT = Handlebars.compile(formTemplate);
            formInfoWrap.html(handlebarsT(data));
            isEmptyFormQInfo = false;
        }
        // eslint-disable-next-line consistent-return
        $.each(colModel, function (i, column) {
            var name = column.name;
            var value = data[name];
            var config = column.config || {};
            var layout = $.ezdia.defaultColumnLayout(column);
            if (column.config && column.config.isFormHidden) {
                return true;
            }
            if (column.config && column.edittype === 'multiple') {
                if (!formTemplate) {
                    var valuesT = getColDataString(column.edittype, value);
                    formInfoWrap.html(valuesT);
                }
                isEmptyFormQInfo = false;
                return true;
            }
            if (!column.editable && !value && column.edittype !== 'json') {
                // eslint-disable-next-line consistent-return
                return;
            }
            var inputs = '';
            var row = null;
            var values = getColDataString(column.edittype, value);
            var obj = {
                column: column,
                value: values
            };
            if (column.config && column.config.accountName) {
                column.edittype = 'group';
                $.extend(column.config, { options: _this.cache.accounts });
            }
            if (column.required || config.validate_rules) {
                $.ezdia.validate.init(validatorObj, column);
            }
            if (column.edittype === 'inputtab') {
                hastabfield = true;
            }
            column.localStorage = cache.editfrm.attr('id');
            column.id = "ez-form-" + actiontype + "-" + name;
            if (column.edittype === 'date') {
                if (value) {
                    var year = value.split('-')[0];
                    if (year === '0000' || year === '9999' || year === '9998') {
                        obj.value = '';
                    }
                }
            }
            if (column.edittype === 'date' && !column.editable && !obj.value) {
                return true;
            }
            if (!column.editable &&
                obj.value &&
                column.edittype !== 'hidden' &&
                column.edittype !== 'html' &&
                column.edittype !== 'comment' &&
                column.edittype !== 'groupField') {
                row = $.ezdia.inputs.readonlyView(obj, actiontype, template);
                if (column.entity) {
                    row.find('[data-row="input"]').attr('id', column.id || column.name);
                }
            }
            else {
                if (column.edittype !== 'hidden') {
                    showUpdateBtn = true;
                }
                inputs = $.ezdia.inputs.create(obj, actiontype);
                row = $.ezdia.inputs.rowMarkup(template, $.extend({}, column, { values: values }), inputs);
            }
            if (column.edittype === 'hidden') {
                cache.editfrminputs.prepend(row);
            }
            else if (column.edittype === 'inputtab') {
                cache.editfrminputs.append(row);
            }
            else {
                $.ezdia.groupFormField.append(column.groupName, row, {
                    type: column.edittype,
                    editable: column.editable,
                    layout: layout
                });
            }
            if (column.edittype === 'creativebrief') {
                briefObj = {
                    name: name,
                    value: value
                };
            }
            $.ezdia.widgets.init(obj, actiontype);
            if (config.accountName) {
                column.edittype = 'text';
            }
        });
        if (isEmptyFormQInfo) {
            formInfoWrap.empty();
        }
    }
    function createWidgets() {
        $.ezdia.widgets.create(actiontype);
        this.cache.editfrm.localStorage('destroy').localStorage({
            accountKey: accountKey,
            cols: pageParams.colModel
        });
        $.ezdia.quickAction.fieldsAdditionalOptions();
        $.ezdia.groupFormField.hide('edit');
    }
    function submitFrm(ignoreWarning, actionUrl) {
        if ($('#createAStoreForm').valid()) {
            var activeBtn_1 = $(this);
            activeBtn_1.button('loading');
            var data = $('#createAStoreForm').serialize();
            data += "&formtype=" + pageParams.formType;
            data += "&allAccountAccess=" + pageParams.allAccess;
            data += "&ignoreWarning=" + ignoreWarning;
            $.ajax({
                type: 'POST',
                url: actionUrl || 'SubmitStoreForm.htm',
                data: data,
                dataType: 'json',
                success: function (response) {
                    if (response.warning) {
                        var wrapper = $.ezdia.getWrapper('statusMsg');
                        wrapper.html(response.msg);
                        wrapper.dialog({
                            modal: true,
                            title: 'Status Update',
                            width: 300,
                            height: 200,
                            buttons: {
                                Continue: function () {
                                    submitFrm(true, actionUrl);
                                    $(this).dialog('close');
                                },
                                Cancel: function () {
                                    $(this).dialog('close');
                                }
                            }
                        });
                    }
                    else {
                        $('#createAStoreForm').isDirty('clearUnload');
                        var url = '';
                        if (response.success) {
                            url = pageParams.ctx + "/desk/ShowStoreForm.htm?formtype=" + pageParams.formType;
                            if (response.accountName) {
                                url = url + "&accountName=" + response.accountName;
                            }
                        }
                        var obj = {
                            response: response.msg,
                            success: response.success,
                            url: url
                        };
                        $('#createAStoreForm').localStorage('discard');
                        successErrorDialog(obj);
                    }
                },
                error: function (response) {
                    var obj = {
                        response: response,
                        success: false,
                        url: ''
                    };
                    successErrorDialog(obj);
                }
            }).always(function () {
                activeBtn_1.button('reset');
            });
        }
    }
    var autoComplete = function () {
        var accounts = [];
        if (pageParams.displayByAccount) {
            if (pageParams.allProjects) {
                var projects = ezdia.util.jsonParse(pageParams.allProjects);
                $.each(projects, function (key, accountInfo) {
                    $.each(accountInfo, function (accName, accLabel) {
                        accounts.push({ value: accName, label: accLabel });
                        self.cache.accounts[accName] = accLabel;
                    });
                });
            }
        }
        $('[name=account_name], [name=tool_name]').autocomplete({
            source: accounts,
            minLength: 0,
            focus: function (event, ui) {
                // prevent autocomplete from updating the textbox
                event.preventDefault();
                $(this).val(ui.item.label);
            },
            select: function (event, ui) {
                event.preventDefault();
                // manually update the textbox and hidden field
                $(this).val(ui.item.label);
                $('#account_name_val').val(ui.item.value);
            }
        });
    };
    var commentFieldsData = function () {
        var content = {};
        var selIds = ezdia.util.getSelectedGridItemsByGridId();
        var data = '';
        data += "&ids=" + selIds;
        data += "&accountName=" + pageParams.account;
        data += "&formtype=" + pageParams.formType;
        data += "&userManagement=" + pageParams.userManagement;
        $.ajax({
            url: 'getItemComments.htm',
            data: data,
            type: 'GET',
            async: false,
            dataType: 'json',
            success: function (res) {
                content = res;
            },
            error: function (res) {
                // eslint-disable-next-line no-console
                console.log(res);
            }
        });
        return content;
    };
    function allAccounts() {
        this.cache = this.cache || {};
        if (pageParams.displayByAccount) {
            this.cache.accounts = {};
            if (pageParams.allProjects) {
                var projects = ezdia.util.jsonParse(pageParams.allProjects);
                $.each(projects, function (key, accounts) {
                    $.each(accounts, function (accName, accLabel) {
                        self.cache.accounts[accName] = accLabel;
                    });
                });
            }
        }
    }
    var getBriefValues = function (frm) {
        var obj = {};
        frm.find('[name]').each(function each() {
            var element = this;
            obj[element.name] = element.value;
        });
        return {
            Brief: [obj]
        };
    };
    var getPreviewContent = function (frm) {
        var initbriefObj = {};
        $.ezdia.creativeBrief.init(initbriefObj, {
            name: 'brief',
            key: 'brief',
            value: 'value',
            editable: false,
            preview: true
        });
        // eslint-disable-next-line no-underscore-dangle
        initbriefObj._value = getBriefValues(frm);
        return $.ezdia.creativeBrief.create(initbriefObj);
    };
    var createPreview = function (content, error) {
        var html = content;
        var buttons = [
            {
                text: 'Close',
                class: 'btn-link',
                click: function () {
                    $(this).dialog('close');
                }
            }
        ];
        var tabsTemplate = '';
        var tabsContent = '';
        var wrapperObj = $('#ez-brief-field-preview-wrapper');
        if (!wrapperObj.length) {
            var divs = $('<div>', {
                id: 'ez-brief-field-preview-wrapper'
            });
            $('body').append(divs);
        }
        wrapperObj = $('#ez-brief-field-preview-wrapper');
        if (error) {
            html = 'Please Enter Some Data.';
        }
        var elem = $('[name=new_tab]');
        var tabsArray = elem.val();
        tabsArray = $.ezdia.getJsonObject(tabsArray);
        if (tabsArray && tabsArray.length > 1) {
            buttons.push.apply(buttons, __spread([
                {
                    text: 'Rearrange tabs',
                    class: 'btn-default',
                    click: function (e) {
                        rearrangeTabs.call(this, e);
                    }
                },
                {
                    text: 'Done',
                    class: 'btn-default',
                    style: 'display: none',
                    click: function (e) {
                        self.updateTab(this);
                        rearrangeTabs.call(this, e, true);
                    }
                }
            ]));
            tabsTemplate = $.ezdia.template.get('creative-brief-rearrange-tabs');
            tabsContent = tabsTemplate(tabsArray);
        }
        wrapperObj.html(html + tabsContent).dialog({
            modal: true,
            title: 'Creative Brief Preview',
            width: '100%',
            height: window.innerHeight || 450,
            buttons: buttons
        });
        wrapperObj.find('.ez-content-brief-tab').sortable({
            items: '[data-sortable]',
            cursor: 'move',
            containment: '.ez-content-brief-tab'
        });
        $('#ez_js_sys_creative_brief_tab').scrollingNav();
    };
    function rearrangeTabs(event, hide) {
        var wrap = $(this);
        var btnHide = $(event.currentTarget).hide();
        var content = wrap.find('[data-content="creative brief"]');
        var tabs = wrap.find('[data-content="creative brief tab"]');
        if (hide) {
            btnHide.prev().show();
            content.show();
            tabs.hide();
        }
        else {
            btnHide.next().show();
            content.hide();
            tabs.show();
        }
    }
    var updateExportCols = function (arr) {
        var arrLen = arr.length;
        $.each(pageParams.exportCols, function (i, obj) {
            if (!arrLen || arr.includes(obj.name)) {
                obj.hidden = false;
            }
            else {
                obj.hidden = true;
            }
        });
    };
    var getExportColumns = function () {
        var arr = [];
        var isAll = $('input[data-column="export all"]').is(':checked');
        if (!isAll) {
            $('input[data-column="export"]:checkbox:checked').each(
            // eslint-disable-next-line consistent-return
            function each(i) {
                var val = this.value;
                if (val.toLowerCase() === 'id') {
                    return true;
                }
                arr[i] = val;
            });
        }
        return arr;
    };
    var exports = function (query, arr) {
        genericExport(query, arr || getExportColumns());
    };
    function exportPopover(query, content) {
        var popover = $(this).popupList({
            content: content,
            itemTemplate: 'grid-column-export',
            placement: function (context) {
                $(context).multiItemCheckList();
                return 'auto';
            },
            buttons: {
                Export: function () {
                    exports(query);
                    popover.popupList('destroy');
                },
                Reset: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var settingData, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    settingData = ezdia.util.getUserSettingData({
                                        action: 'export'
                                    });
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, ezdia.util.clearUserSettings(settingData)];
                                case 2:
                                    _a.sent();
                                    popover.popupList('destroy');
                                    window.location.reload();
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    });
                },
                Save: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var arr, exportColumns, settingData;
                        return __generator(this, function (_a) {
                            arr = getExportColumns();
                            exportColumns = arr.join(',');
                            settingData = ezdia.util.getUserSettingData({
                                action: 'export',
                                columnValue: exportColumns
                            });
                            try {
                                ezdia.util.saveUserSettings(settingData);
                                updateExportCols(arr);
                                exports(query, arr);
                            }
                            catch (error) {
                                //
                            }
                            finally {
                                popover.popupList('destroy');
                            }
                            return [2 /*return*/];
                        });
                    });
                }
            }
        });
        $('body')
            .off('.ez.export.body.click')
            .on('click.ez.export.body.click', function click(e) {
            var par = "#popover_" + popover.attr('id');
            var isElem = popover.attr('id') === $(e.target).attr('id');
            if (!$(e.target).parents(par).length && !isElem) {
                popover.popupList('destroy');
                $(this).off('.columnExportBodyClick');
            }
        });
    }
    var storeFormObj = {
        init: function () {
            self = this;
            pageParams = $.ezdia.config.pageParams;
            actiontype = pageParams.formType || 'form';
            this.cache = {
                editfrm: $('#ez-edit-store-form'),
                editfrmCol: $('#ez-edit-store-form-col'),
                editfrminputs: $('#ez-edit-store-form-inputs'),
                bulkEditFrm: $('#bulkEditFrm'),
                quickactionfield: $('#quickactionfield'),
                updateBtn: $('#ez-edit-store-form-update')
            };
            allAccounts.call(this);
            ezdia.component.form.closeFormBtn('ez-js-form-right-close');
        },
        load: function () {
            this.init();
            if (pageParams.displayByAccount) {
                var accName = $('#accountName').val(pageParams.account);
                accName.sortItems().chosen({
                    placeholder_text: '',
                    disable_search_threshold: 10
                });
                $('#accountName').change(function () {
                    var params = "&accountName=" + $('#accountName').val();
                    window.location.href = "ShowStoreForm.htm?formtype=" + pageParams.formType + params;
                });
            }
            this.search();
            this.grid();
            this.quickAction();
            this.cache.updateBtn.on('click', this.update);
            $('#ez-edit-store-form-preview').on('click', this.preview);
            $('#ez-edit-store-form-cancel').on('click', this.cancel);
            $('#ez-project-nav').scrollingNav({
                clickable: true,
                offsets: ['ez-page-top-navbar', 'ez-js-form-top-info-and-nav']
            });
            pageLoadingDone();
            $.ezdia.stickyFormBtns({
                sticky: 'editForm-main',
                frm: 'ez-edit-store-form'
            });
        },
        grid: function () {
            var rowNum = 10;
            pageParams.fetchFields = [];
            var dataUrl = 'StoreFormGridData.htm';
            if (pageParams.showFormUrl) {
                dataUrl = pageParams.showFormUrl;
            }
            $.ezdia.grid.create({
                id: 'grid',
                url: dataUrl,
                datatype: 'json',
                mtype: 'POST',
                postData: {
                    formtype: function () {
                        return pageParams.formType;
                    },
                    accountName: function () {
                        return pageParams.account;
                    },
                    searchCondition: function () {
                        return $('#searchFrm').search('getQueryString');
                    }
                },
                colModel: pageParams.colModel,
                colNames: pageParams.colNames,
                rowNum: rowNum,
                multiselect: pageParams.isGridMultiselect,
                beforeSelectRow: $.ezdia.desk.grid.beforeSelectRow,
                onSelectRow: self.onSelectRow,
                onSelectAll: self.onSelectRow,
                loadComplete: self.loadComplete,
                importFn: function () {
                    window.location.href = pageParams.ctx + "/desk/ImportData.htm?formtype=" + pageParams.formType + "&genericImport=true";
                },
                isExport: pageParams.export,
                customeBtnsWrapId: 'ez-js-grid-actions-btns',
                hidegrid: false,
                gridview: true
            });
        },
        onSelectRow: function (ids, clicked) {
            var grid = $(this);
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            var accountName = null;
            var deselectrow = grid.jqGrid('getGridParam', 'deselectrow');
            if ((selIds && selIds.length > 1) || deselectrow) {
                hideShowDeskForm('#bulkEditFrm');
                getSelectedIdsMarkup(selIds);
                ezdia.component.form.show();
                if (deselectrow) {
                    grid.jqGrid('resetSelection');
                    grid.jqGrid('setGridParam', { deselectrow: false });
                }
            }
            else if (ids && selIds.length === 1) {
                // eslint-disable-next-line no-param-reassign
                ids = selIds.toString();
                accountKey = pageParams.formType + ids;
                resetSelectedRow.call(self);
                ezdia.component.form.show();
                var rowData = $('#grid').jqGrid('getRowData', ids);
                form.call(self, {
                    data: rowData
                });
                if (pageParams.displayByAccount) {
                    self.cache.editfrm.find('#account_name_val').remove();
                    self.cache.editfrm.append('<input id="account_name_val" name="account_name_val" type="hidden"/>');
                }
                accountName = rowData.account_name || '';
                if (pageParams.displayByAccount &&
                    accountName.includes('All') &&
                    !pageParams.allAccess) {
                    $('#message').html('You donot have permission to update this filter for all projects');
                    self.cache.updateBtn.hide();
                }
                else {
                    self.cache.updateBtn.show();
                }
                if (showUpdateBtn) {
                    $('#editForm-main').show();
                }
                else {
                    $('#editForm-main').hide();
                }
            }
            else if (!selIds.length) {
                hideShowDeskForm('');
                ezdia.component.form.hide();
            }
            toggleQuickLinks.call(this, selIds, clicked);
        },
        loadComplete: function () {
            var $grid = $('#grid');
            var recordCount = $grid.jqGrid('getGridParam', 'records');
            var rowNum = $grid.jqGrid('getGridParam', 'rowNum');
            var gridCaption = pageParams.gridCaption;
            if (pageParams.isGridMultiselect && recordCount > rowNum) {
                gridCaption = ezdia.templates.grid.countAndSelectCaption(recordCount);
            }
            gridCaption = ezdia.templates.grid.caption(gridCaption);
            $grid.jqGrid('setCaption', gridCaption);
            hideShowDeskForm('#bulkEditFrm');
            ezdia.component.form.hide();
            setGridCellTitle();
            if (pageParams.sysSelectFirst) {
                $.ezdia.grid.selectFirstItem('#grid');
            }
        },
        export: function (query) {
            pageParams = $.ezdia.config.pageParams;
            var cols = pageParams.exportCols || [];
            var content = {
                selectAll: true,
                colList: cols
            };
            // eslint-disable-next-line consistent-return
            $.each(cols, function (i, o) {
                if (o.hidden) {
                    content.selectAll = false;
                    return false;
                }
            });
            exportPopover.call(this, query, content);
        },
        quickAction: function () {
            var listItems = '';
            var arr = [];
            var quickactionObj = $.ezdia.config.pageParams.quickactionObj;
            listItems = $.ezdia.quickLinks.create(quickactionObj, arr, true);
            if (listItems) {
                $('#qactiondiv').html(listItems);
                $.ezdia.quickLinks.triggersActive('#ez-quick-action-links');
            }
            $.ezdia.showMorelinks();
        },
        update: function () {
            var cache = self.cache;
            var activeBtn = $(this);
            var formType = pageParams.formType, editFormUrl = pageParams.editFormUrl, displayByAccount = pageParams.displayByAccount, account = pageParams.account, allAccess = pageParams.allAccess, channel = pageParams.channel, userManagement = pageParams.userManagement;
            var data = cache.editfrm.serialize();
            data += "&formtype=" + formType;
            var editActionUrl = editFormUrl;
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            data += "&ids=" + selIds;
            data += "&accountName=" + account;
            if (displayByAccount) {
                data += "&allAccountAccess=" + allAccess;
            }
            if (userManagement) {
                data += "&userManagement=" + userManagement;
            }
            data += "&channel=" + channel;
            if (cache.editfrm.valid()) {
                activeBtn.button('loading');
                $.ajax({
                    type: 'POST',
                    url: editActionUrl || 'EditStoreForm.htm',
                    data: data,
                    dataType: 'text',
                    success: function (resp) {
                        var response = $.ezdia.getJsonObject(resp) || {};
                        if (response.success) {
                            $.ezdia.successMsg(response.msg || 'Data updated successfully');
                            $('#grid').trigger('reloadGrid');
                            self.cache.editfrm.hide().localStorage('discard');
                        }
                        else {
                            $.ezdia.successMsg(response.msg || 'Error updating data', true);
                        }
                    },
                    error: function (response) {
                        $.ezdia.successMsg(response.msg, true);
                    }
                }).always(function () {
                    activeBtn.button('reset');
                });
            }
        },
        cancel: function () {
            self.cache.editfrm.hide();
            self.cache.editfrminputs.empty();
            $('#message').html('');
        },
        submitQuickAction: function (e, QAObj) {
            var formType = pageParams.formType, channel = pageParams.channel, account = pageParams.account, userManagement = pageParams.userManagement;
            var $form = $('#bulkEditFrm');
            var data = '';
            var activeBtn = $("#" + e.target.getAttribute('id'));
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            var selectAll = $('#selectAll').is(':checked');
            if (selectAll) {
                selIds = getFormAllItemIds();
            }
            if (!$form.valid()) {
                return;
            }
            activeBtn.button('loading');
            data = $form.serialize();
            if (account) {
                data += "&accountName=" + account;
            }
            if (userManagement) {
                data += "&userManagement=" + userManagement;
            }
            data += "&ids=" + selIds;
            data += "&formtype=" + formType;
            data += "&quickActionName=" + ezdia.config.currentQuickAction;
            data += "&channel=" + channel;
            $.ajax({
                type: 'POST',
                url: QAObj.actionUrl || 'EditStoreForm.htm',
                data: data,
                dataType: 'text',
                success: function (resp) {
                    var response = $.ezdia.getJsonObject(resp) || {};
                    if (response.success) {
                        $.ezdia.successMsg(response.msg || QAObj.successMsg || 'Data updated successfully');
                        $('#grid').trigger('reloadGrid');
                        $('#editStoreForm').hide();
                    }
                    else {
                        $.ezdia.successMsg(response.msg || QAObj.errorMsg || 'Error updating data', true);
                    }
                },
                error: function (response) {
                    $.ezdia.successMsg(response.responseText, true);
                }
            }).always(function () {
                activeBtn.button('reset');
            });
        },
        create: function () {
            var frm = $('#createAStoreForm');
            self = this;
            pageParams = $.ezdia.config.pageParams;
            actiontype = pageParams.formType || 'form';
            var createActionUrl = pageParams.createFormActionUrl;
            $.ezdia.form.init();
            $.ezdia.groupFormField.jspGroup('#ez-content');
            // $.ezdia.validate.create(pageParams.required, 'createAStoreForm');
            $.ezdia.validate.all(pageParams.colModel, 'createAStoreForm');
            $.ezdia.widgets.renderAll(pageParams.colModel, actiontype);
            $('#createAStoreFormBtn').on('click', function () {
                submitFrm(false, createActionUrl);
            });
            allAccounts.call(this);
            autoComplete();
            frm.isDirty();
            frm.localStorage('destroy').localStorage({
                accountKey: pageParams.formType + ".new",
                cols: pageParams.colModel
            });
            $('#ez-edit-store-form-preview').on('click', this.preview);
            $('#ez-project-nav').scrollingNav();
            pageLoadingDone();
        },
        form: function (ids, renderWidets) {
            pageParams = $.ezdia.config.pageParams;
            actiontype = pageParams.formType || 'form';
            var rowData = $('#grid').jqGrid('getRowData', ids);
            form.call(this, {
                data: rowData
            }, renderWidets);
        },
        createWidgets: function () {
            createWidgets.call(this);
        },
        resetSelectedRow: function () {
            pageParams = $.ezdia.config.pageParams;
            resetSelectedRow.call(this);
        },
        getFormAllItemIds: function () {
            pageParams = $.ezdia.config.pageParams;
            var ids = formAllItemIds.call(this);
            return ids;
        },
        preview: function (e) {
            pageParams = $.ezdia.config.pageParams;
            var elem = $(e.currentTarget);
            var frm = elem.closest('form');
            var context = getPreviewContent(frm);
            createPreview(context);
        },
        updateTab: function (wrapper) {
            var elem = $('[name=new_tab]');
            var value = elem.val();
            var panel = $(wrapper);
            var tabs = panel.find('[data-sortable]');
            var arr = [];
            value = $.ezdia.getJsonObject(value);
            if (!value) {
                return;
            }
            $.each(tabs, function each(i) {
                var index = $(this).data('sortable');
                arr[i] = value[index];
            });
            value = JSON.stringify(arr);
            elem.val(value).inputTab('refresh');
            panel.dialog('close');
        },
        search: function () {
            var _a = $.ezdia.config.pageParams.showFormUrl, showFormUrl = _a === void 0 ? '' : _a;
            $.ezdia.initGenericSearch('#searchFrm', this.export, showFormUrl);
        },
        getAllItemIds: function () {
            return formAllItemIds();
        }
    };
    var pages;
    (function (pages) {
        pages.storeForm = storeFormObj;
    })(pages = ezdia.pages || (ezdia.pages = {}));
    /*
     ** This $.ezdia is just for old code support
     ** DON'T USE THIS
     */
    $.ezdia.storeForm = storeFormObj;
})(ezdia || (ezdia = {}));
